var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.renderComponent)?_c('div',{staticClass:"d-flex flex-end col-sm-12 p-md-0"},[_c('div',{attrs:{"id":"Prematchstatscore"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }